import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { initSentry } from './lib/sentry';
import App from './App';
import './index.css';
import { ThemeProvider } from './contexts/ThemeContext';
import { EmployeeProvider } from './contexts/EmployeeContext';
import { AuthProvider } from './contexts/AuthContext';
import { HQProvider } from './contexts/HQContext';

initSentry();

function FallbackUI() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui' }}>
      <h1 style={{ fontSize: '1.25rem', marginBottom: '0.5rem' }}>Something went wrong</h1>
      <p style={{ color: '#666' }}>Please refresh the page to try again.</p>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <EmployeeProvider>
              <HQProvider>
                <App />
              </HQProvider>
            </EmployeeProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
